// extracted by mini-css-extract-plugin
module.exports = {"landingParagraph":"LandingParagraph_landingParagraph__ek0tS"};